export default __webpack_public_path__ + "static/media/icon-breaker.5e0ed161.svg";